/* hb-combo.js — shared combo helpers (Hamster Brain's Trading Post)
   Combo data: Commander Spellbook snapshot (assets/combos.json)
   Card images: Scryfall CDN, full card shown uncropped (artist + copyright intact)
   Stock + price: live, via Shopify's own /search/suggest.json */
(function(){
  var Q = String.fromCharCode(63), LB = String.fromCharCode(91), RB = String.fromCharCode(93);
  var dataP = null, cardsP = null, CARDS = null, stockCache = {};

  function norm(s){
    return (s||'')
      .normalize ? (s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'')
        .replace(/[\u2018\u2019\u02bc]/g, "'").replace(/[\u2013\u2014]/g, '-')
        .toLowerCase().replace(/\u00e6/g,'ae').replace(/\u0153/g,'oe')
        .replace(/\s+/g,' ').trim()
      : (s||'').toLowerCase().replace(/\s+/g,' ').trim();
  }
  /* punctuation-insensitive form, for last-resort matching */
  function loose(s){ return norm(s).replace(/[^a-z0-9]+/g,''); }
  /* front face of a split / modal card */
  function front(s){ return String(s||'').split(' // ')[0]; }
  function esc(s){ var d = document.createElement('div'); d.textContent = s==null?'':String(s); return d.innerHTML; }
  function money(n){ return '$' + Number(n).toFixed(2); }

  function loadCards(){
    if(!cardsP) cardsP = fetch(window.HB_COMBO_CARDS).then(function(r){ return r.json(); })
      .then(function(j){ CARDS = j; return j; }).catch(function(){ return { names:[], cards:{} }; });
    return cardsP;
  }
  function loadData(){
    if(!dataP) dataP = fetch(window.HB_COMBOS).then(function(r){ return r.json(); });
    return dataP;
  }

  function cardImg(name){
    if(!CARDS || !CARDS.cards) return null;
    var v = CARDS.cards[name];
    if(!v) return null;
    var p = v.split('|'), id = p[0], ts = p[1];
    return 'https://cards.scryfall.io/normal/front/' + id.charAt(0) + '/' + id.charAt(1) + '/' + id + '.jpg' + (ts ? (Q + ts) : '');
  }
  function cardType(name){ return (CARDS && CARDS.types && CARDS.types[name]) || ''; }

  /* Local stock index: a snapshot of every published, in-stock product, keyed by
     normalised card name and holding the CHEAPEST printing we carry. Instant, and it
     does not depend on Shopify's predictive-search index having caught up. */
  var stockIdxP = null, STOCK_IDX = null;
  function loadStockIndex(){
    if(!stockIdxP){
      stockIdxP = (window.HB_STOCK
        ? fetch(window.HB_STOCK).then(function(r){ return r.json(); })
        : Promise.resolve(null)
      ).then(function(j){ STOCK_IDX = j && j.idx ? j.idx : {}; return STOCK_IDX; })
       .catch(function(){ STOCK_IDX = {}; return STOCK_IDX; });
    }
    return stockIdxP;
  }
  function fromIndex(name){
    if(!STOCK_IDX) return undefined;
    var row = STOCK_IDX[norm(name)] || STOCK_IDX[norm(front(name))];
    if(!row) return null;
    return { title: row[0], price: row[1], url: '/products/' + row[2], available: true, fromIndex: true };
  }

  function suggest(name){
    if(stockCache[name]) return stockCache[name];
    var idxHit = fromIndex(name);
    if(idxHit) { stockCache[name] = Promise.resolve(idxHit); return stockCache[name]; }
    var url = '/search/suggest.json' + Q + 'q=' + encodeURIComponent(name)
      + '&resources' + LB + 'type' + RB + '=product'
      + '&resources' + LB + 'limit' + RB + '=8';
    var p = fetch(url).then(function(r){ return r.json(); }).then(function(j){
      var list = (j.resources && j.resources.results && j.resources.results.products) || [];
      var want = norm(name), wantF = norm(front(name)), wantL = loose(name), wantLF = loose(front(name));
      function ok(pr){
        if(!pr.available) return false;
        var t = norm(pr.title);
        if(t === want || t === wantF) return true;
        if(t.indexOf(want + ' ' + LB) === 0 || t.indexOf(want + ' (') === 0) return true;
        if(t.indexOf(wantF + ' ' + LB) === 0 || t.indexOf(wantF + ' (') === 0) return true;
        /* last resort: ignore punctuation, but only against the part before the set bracket */
        var head = loose(pr.title.split(' ' + LB)[0].split(' (')[0]);
        return head === wantL || head === wantLF;
      }
      var hits = list.filter(ok);
      hits.sort(function(a,b){ return parseFloat(a.price) - parseFloat(b.price); });
      return hits[0] || null;
    }).catch(function(){ return null; });
    stockCache[name] = p;
    return p;
  }

  function pool(items, worker, limit){
    var idx = 0, active = 0;
    return new Promise(function(resolve){
      function next(){
        if(idx >= items.length && active === 0) return resolve();
        while(active < limit && idx < items.length){
          var it = items[idx++]; active++;
          worker(it).then(function(){ active--; next(); }, function(){ active--; next(); });
        }
      }
      next();
    });
  }

  function identityOk(k, on){
    if(!k || k === 'C') return true;
    for(var i=0;i<k.length;i++){ if(k.charAt(i) !== 'C' && on.indexOf(k.charAt(i)) === -1) return false; }
    return true;
  }
  function pips(k){
    var s = (k && k !== 'C') ? k : 'C', h = '<span class="cmb__ident">';
    for(var i=0;i<s.length;i++){ h += '<span class="cmb__ci cmb__ci--' + s.charAt(i) + '">' + s.charAt(i) + '</span>'; }
    return h + '</span>';
  }

  function figure(name, opts, flag){
    var img = cardImg(name), cls = 'cmb__fig';
    if(flag === 'this') cls += ' cmb__fig--this';
    if(flag === 'owned') cls += ' cmb__fig--owned';
    if(flag === 'need') cls += ' cmb__fig--need';
    var h = '<figure class="' + cls + '">';
    h += '<div class="cmb__art">';
    if(img) h += '<img src="' + img + '" alt="' + esc(name) + '" loading="lazy" width="488" height="680">';
    else h += '<div class="cmb__noart">' + esc(name) + '</div>';
    if(flag === 'this') h += '<span class="cmb__ribbon">This card</span>';
    else if(flag === 'owned') h += '<span class="cmb__ribbon cmb__ribbon--own">In your deck</span>';
    else if(flag === 'need') h += '<span class="cmb__ribbon cmb__ribbon--need">You need this</span>';
    h += '</div>';
    h += '<figcaption><span class="cmb__cname">' + esc(name) + '</span>';
    if(flag === 'this') h += '<span class="cmb__stock cmb__stock--this">on this page</span>';
    else if(flag === 'owned') h += '<span class="cmb__stock cmb__stock--this">already yours</span>';
    else h += '<span class="cmb__stock cmb__stock--wait" data-card="' + esc(name) + '">checking&hellip;</span>';
    h += '</figcaption></figure>';
    return h;
  }

  /* opts: highlight, owned(fn), need (name), compact, noBadge */
  function comboHTML(c, opts){
    opts = opts || {};
    var hi = opts.highlight ? norm(opts.highlight) : null;
    var need = opts.need ? norm(opts.need) : null;
    var n = (c.u || []).length + (c.r || []).length;
    var h = '<article class="cmb__combo" data-id="' + esc(c.i) + '">';

    h += '<div class="cmb__cards' + (n > 3 ? ' cmb__cards--many' : '') + '">';
    (c.u || []).forEach(function(nm){
      var flag = null;
      if(hi && norm(nm) === hi) flag = 'this';
      else if(need && norm(nm) === need) flag = 'need';
      else if(opts.owned && opts.owned(nm)) flag = 'owned';
      h += figure(nm, opts, flag);
    });
    (c.r || []).forEach(function(t){
      h += '<figure class="cmb__fig cmb__fig--tpl"><div class="cmb__art"><div class="cmb__noart cmb__noart--tpl">' + esc(t) + '</div></div>'
         + '<figcaption><span class="cmb__cname">Any ' + esc(t) + '</span></figcaption></figure>';
    });
    h += '</div>';

    h += '<div class="cmb__body">';
    h += '<div class="cmb__ctop"><span class="cmb__count">' + n + ' card combo</span>' + pips(c.k);
    if(c.m) h += '<span class="cmb__mana">Needs ' + esc(c.m) + '</span>';
    if(!opts.noBadge) h += '<span class="cmb__badge" data-badge>Checking stock&hellip;</span>';
    h += '</div>';

    if(c.p && c.p.length){
      h += '<ul class="cmb__makes">';
      c.p.slice(0, opts.compact ? 4 : 8).forEach(function(f){
        var inf = /^infinite/i.test(f);
        h += '<li class="cmb__make' + (inf ? ' cmb__make--inf' : '') + '">' + (inf ? '<b>&infin;</b>' : '') + esc(f.replace(/^Infinite /,'')) + '</li>';
      });
      if(c.p.length > (opts.compact ? 4 : 8)) h += '<li class="cmb__make cmb__make--more">+' + (c.p.length - (opts.compact ? 4 : 8)) + ' more</li>';
      h += '</ul>';
    }
    if(!opts.compact && c.n) h += '<p class="cmb__pre"><b>Before you start</b>' + esc(c.n) + '</p>';
    if(c.d) h += '<p class="cmb__steps">' + esc(c.d) + '&hellip;</p>';
    h += '<a class="cmb__link" target="_blank" rel="noopener" href="https://commanderspellbook.com/combo/' + esc(c.i) + '/">Full combo on Commander Spellbook &rarr;</a>';
    h += '</div></article>';
    return h;
  }

  function markBadges(scope){
    Array.prototype.forEach.call(scope.querySelectorAll('.cmb__combo'), function(art){
      var cells = art.querySelectorAll('[data-card]');
      var b = art.querySelector('[data-badge]');
      if(!b) return;
      if(!cells.length){ b.remove(); return; }
      var missing = 0;
      Array.prototype.forEach.call(cells, function(x){ if(x.classList.contains('cmb__stock--no')) missing++; });
      if(missing === 0){ b.textContent = 'Every piece in stock'; b.className = 'cmb__badge cmb__badge--all'; art.setAttribute('data-all','1'); }
      else { b.textContent = missing + ' of ' + cells.length + ' not in stock'; b.className = 'cmb__badge'; art.removeAttribute('data-all'); }
    });
  }

  function resolveStock(scope, done){
    var nodes = scope.querySelectorAll('[data-card]'), names = [];
    var idxReady = loadStockIndex();
    Array.prototype.forEach.call(nodes, function(x){
      var v = x.getAttribute('data-card');
      if(names.indexOf(v) === -1) names.push(v);
    });
    return idxReady.then(function(){ return pool(names, function(name){
      return suggest(name).then(function(hit){
        var sel = scope.querySelectorAll('[data-card="' + name.replace(/"/g,'&quot;') + '"]');
        Array.prototype.forEach.call(sel, function(x){
          x.classList.remove('cmb__stock--wait');
          var fig = x.closest ? x.closest('.cmb__fig') : null;
          if(hit){
            x.innerHTML = '<a href="' + esc(hit.url) + '"><b>' + money(hit.price) + '</b><span>in stock</span></a>';
            x.classList.add('cmb__stock--yes');
            if(fig) fig.classList.add('is-stocked');
          } else {
            x.classList.add('cmb__stock--no');
            x.innerHTML = '<a href="/search' + Q + 'q=' + encodeURIComponent(name) + '"><b>&mdash;</b><span>not in stock</span></a>';
            if(fig) fig.classList.add('is-out');
          }
        });
      });
    }, 5); }).then(function(){ markBadges(scope); if(done) done(); });
  }

  /* Resolve a list of card names to {name: product|null} before rendering.
     Lets a page render only what is actually in stock. */
  function resolveNames(names){
    var outMap = {};
    return loadStockIndex().then(function(){ return pool(names, function(n){
      return suggest(n).then(function(hit){ outMap[n] = hit || null; });
    }, 6); }).then(function(){ return outMap; });
  }

  /* Walk a candidate list in chunks, resolving stock, until we have `want` in-stock
     items or we run out / hit the lookup budget. Returns {hits, checked, exhausted}. */
  function takeInStock(list, keyOf, want, budget){
    var i = 0, hits = [], checked = 0;
    budget = budget || 260;
    function step(){
      if(hits.length >= want || i >= list.length || checked >= budget) {
        return Promise.resolve({ hits: hits, checked: checked, exhausted: i >= list.length });
      }
      var chunk = list.slice(i, i + 30);
      i += chunk.length;
      checked += chunk.length;
      return resolveNames(chunk.map(keyOf)).then(function(m){
        chunk.forEach(function(it){ var h = m[keyOf(it)]; if(h){ it.__hit = h; hits.push(it); } });
        return step();
      });
    }
    return step();
  }

  window.HBCombo = {
    norm: norm, loose: loose, front: front, esc: esc, money: money,
    loadCards: loadCards, loadData: loadData, cardImg: cardImg, cardType: cardType,
    loadStockIndex: loadStockIndex, fromIndex: fromIndex,
    suggest: suggest, pool: pool, figure: figure,
    identityOk: identityOk, pips: pips, comboHTML: comboHTML,
    resolveStock: resolveStock, markBadges: markBadges,
    resolveNames: resolveNames, takeInStock: takeInStock
  };
})();